import React from 'react'
import PropTypes from 'prop-types'
import { Box, Switch, Typography } from '@mui/material'
import { mainBlue, mainWhite } from 'utils/constants/ColorTheme'

const ChartOptionToggle = ({
    label = '',
    checked = false,
    onChange = () => {},
    disabled = false,
    swatch,
}) => (
    <Box
        onClick={() => !disabled && onChange(!checked)}
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            border: `1px solid ${mainBlue}`,
            borderRadius: '20px',
            backgroundColor: mainWhite,
            padding: '0 0 0 0.5rem',
            cursor: disabled ? 'default' : 'pointer',
            userSelect: 'none',
        }}
    >
        {swatch}
        <Typography variant='small'>{label}</Typography>
        <Switch
            size='small'
            checked={checked}
            disabled={disabled}
            sx={{ pointerEvents: 'none' }}
        />
    </Box>
)

ChartOptionToggle.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    swatch: PropTypes.node,
}

export default ChartOptionToggle
